import React from 'react'
import Button from '@blocks/Button'
import Grid from '@blocks/Grid'
import Flex from '@blocks/Flex'

export default function Feature({ title, description, to, cta }: FeatureProps) {
    return (
        <Grid gap="20px">
            <Grid gap="10px">
                <div><h3>{title}</h3></div>
                <p>{description}</p>
            </Grid>
            <Flex><Button type="secondary" width="auto" to={to}>{cta}</Button></Flex>
        </Grid>
    )
}

// TYPES
interface FeatureProps {
    title: React.ReactNode
    description: React.ReactNode
    to: string
    cta: string
}